import {useEffect} from "react";
import {getMobileOperatingSystem} from "../appStoreLink/appStoreLink";

const Redirect = () => {
	useEffect(() => {
		const system = getMobileOperatingSystem();
		const url = window.location;
		let params = new URLSearchParams(url.search);
		let link = params.get('link')
		switch(system) {
			case "iOS": case "Android":
				window.open("com.notifier.com.notifier:/" + link, "_self");
				break;
			default:
				window.open("https://portal.notifier-global.com/" + link, "_self");
		}
	}, [])
	return <div></div>
}

export default Redirect;